import { apiEndpoints } from '@/apiEndpoints';
import { DistributorDataWithStats } from '@/types/admin/allDistributorsColumnDef';
import { ReceiverDataWithStats } from '@/types/admin/allReceiversColumnDef';
import axios from 'axios';

export type AllReceiversParams = {
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
  filters?: {
    month?: string; // Expected format: 'YYYY-MM'
  };
};

type AllReceiversResponse = {
  receivers: ReceiverDataWithStats[];
  total: number;
};

export const getAllReceiversWithStats = async (params: AllReceiversParams) => {
  const filtersStr = Object.entries(params.filters ?? {})
    .filter(([, value]) => value)
    .map(([key, value]) => `${key}:${encodeURIComponent(value)}`)
    .join(',');
  const response = await axios.get<AllReceiversResponse>(
    apiEndpoints.admin.receivers,
    { params: { ...params, filters: filtersStr } },
  );
  return response.data;
};

type AllDistributorsResponse = {
  distributors: DistributorDataWithStats[];
  total: number;
};

export const getAllDistributorsWithStats = async (
  params: AllReceiversParams,
) => {
  const filtersStr = Object.entries(params.filters ?? {})
    .filter(([, value]) => value)
    .map(([key, value]) => `${key}:${encodeURIComponent(value)}`)
    .join(',');
  const response = await axios.get<AllDistributorsResponse>(
    apiEndpoints.admin.distributors,
    { params: { ...params, filters: filtersStr } },
  );
  return response.data;
};
